/**
 * PROFIL EMPLOYEE
 */
// Achat
import ceciliafabre from './achat/cecilia.fabre@greenkub.fr.jpg';
import soniacharriere from './achat/sonia.charriere@greenkub.fr.jpg';
import vanessavoitot from './achat/vanessa.voitot@greenkub.fr.jpg';
import mikaeligmeffray from './achat/mikaelig.meffray@greenkub.fr.jpg';
// Compta
import audreysalin from './compta/audrey.salin@greenkub.fr.jpg';
import isabellelefebvre from './compta/isabelle.lefebvre@greenkub.fr.png';
// Conduc
import arthurlambert from './conduc/arthur.lambert@greenkub.fr.jpg';
import christopherramillon from './conduc/christopher.ramillon@greenkub.fr.jpg';
import davidlebee from './conduc/david.lebee@greenkub.fr.jpg';
import erictassigny from './conduc/eric.tassigny@greenkub.fr.jpg';
import ginoscuderi from './conduc/gino.scuderi@greenkub.fr.jpg';
import julienberna from './conduc/julien.berna@greenkub.fr.jpg';
import maximepetitprez from './conduc/maxime.petitprez@greenkub.fr.png';
import sakinaeg from './conduc/sakina.eg@greenkub.fr.png';
import vincentmorel from './conduc/vincent.morel@greenkub.fr.png';
// Controle
import juliemalaval from './controle/julie.malaval@greenkub.fr.jpg';
// Exploitation
import lionelboubal from './exploitation/lionel.boubal@greenkub.fr.png';
import izaorabo from './exploitation/izaora.bo@greenkub.fr.png';
// Marketing
import jeansimondon from './marketing/jean.simondon@greenkub.fr.jpg';
// import jiayihe from './marketing/jiayi.he@greenkub.fr.png'
// import joachimpdb from './marketing/joachim.pdb@greenkub.fr.jpg'
import pierredominguez from './marketing/pierre.dominguez@greenkub.fr.jpg';
// Sales
import berenicejoubert from './sales/berenice.joubert@greenkub.fr.png';
import camillegibelin from './sales/camille.gibelin@greenkub.fr.jpg';
import camillelandre from './sales/camille.landre@greenkub.fr.jpg';
import clementinevidaud from './sales/clementine.vidaud@greenkub.fr.png';
import edithvignat from './sales/edith.vignat@greenkub.fr.jpg';
import laurebailly from './sales/laure.bailly@greenkub.fr.jpg';
import marionbonnifay from './sales/marion.bonnifay@greenkub.fr.jpg';
import maudrochegue from './sales/maud.rochegue@greenkub.fr.jpg';
import oceanepotard from './sales/oceane.potard@greenkub.fr.jpg';
import paulinefournerat from './sales/pauline.fournerat@greenkub.fr.jpg';
import emiliedeblock from './sales/emilie.deblock@greenkub.fr.jpg';
import lauracalcei from './sales/laura.calcei@greenkub.fr.jpg';
import marinecaillis from './sales/marine.caillis@greenkub.fr.jpg';
import solenenavaron from './sales/solene.navaron@greenkub.fr.jpg';
import laurianeheim from './sales/lauriane.heim@greenkub.fr.png';
import oceanefloirac from './sales/oceane.floirac@cover.green.png';

// SDR
import camillepero from './sdr/camille.pero@greenkub.fr.jpg';
import carolineboyenval from './sdr/caroline.boyenval@greenkub.fr.jpg';
import cyril from './sdr/cyril@greenkub.fr.jpg';
import jadequignot from './sdr/jade.quignot@greenkub.fr.png';
import leopaulescude from './sdr/leo-paul.escude@greenkub.fr.jpg';
import omaymamimouni from './sdr/omayma.mimouni@greenkub.fr.jpg';
import sebastienbs from './sdr/sebastien.bs@greenkub.fr.jpg';
import valerieinestal from './sdr/valerie.inestal@greenkub.fr.jpg';
import marcpredieri from './sdr/marc.predieri@greenkub.fr.jpg';
import justineledet from './sdr/justine.ledet@greenkub.fr.jpg';
// Service Client
import corinnebecu from './serviceclient/corinne.becu@greenkub.fr.jpg';
import heleneiovino from './serviceclient/helene.iovino@greenkub.fr.jpg';
import laurabosc from './serviceclient/laura.bosc@greenkub.fr.jpg';
import serviceclients from './serviceclient/serviceclients@greenkub.fr.jpg';
// Urba
import audreypoire from './urba/audrey.poire@greenkub.fr.png';
import clarysse from './urba/clarysse@greenkub.fr.jpg';
import luisperez from './urba/luis.perez@greenkub.fr.png';
import paulagiannini from './urba/paula.giannini@greenkub.fr.png';
import priscilliacalabuig from './urba/priscillia.calabuig@greenkub.fr.jpg';
import remiroux from './urba/remi.roux@greenkub.fr.jpg';
import romaneroussel from './urba/romane.roussel@greenkub.fr.png';
import heloisepro from './urba/heloise.touren@greenkub.fr.png';
import celineregina from './urba/celine.regina@greenkub.fr.png';
import vincentrouah from './urba/vincent.rouah@greenkub.fr.png';
import lucielegastelois from './urba/lucie.legastelois@greenkub.fr.jpg';
// Autre
import alexandre from './alexandre@greenkub.fr.jpg';
import brunosultan from './bruno.sultan@greenkub.fr.jpg';

export const profiles = [
  ceciliafabre,
  vanessavoitot,
  soniacharriere,
  audreysalin,
  isabellelefebvre,
  davidlebee,
  erictassigny,
  julienberna,
  maximepetitprez,
  vincentmorel,
  juliemalaval,
  lionelboubal,
  pierredominguez,
  jeansimondon,
  // jiayihe,
  // joachimpdb,
  berenicejoubert,
  camillegibelin,
  clementinevidaud,
  edithvignat,
  laurebailly,
  oceanepotard,
  camillepero,
  cyril,
  jadequignot,
  leopaulescude,
  omaymamimouni,
  sebastienbs,
  valerieinestal,
  heleneiovino,
  audreypoire,
  clarysse,
  izaorabo,
  paulagiannini,
  priscilliacalabuig,
  romaneroussel,
  heloisepro,
  arthurlambert,
  christopherramillon,
  ginoscuderi,
  sakinaeg,
  camillelandre,
  marionbonnifay,
  maudrochegue,
  paulinefournerat,
  carolineboyenval,
  corinnebecu,
  laurabosc,
  serviceclients,
  luisperez,
  remiroux,
  mikaeligmeffray,
  marcpredieri,
  justineledet,
  alexandre,
  brunosultan,
  emiliedeblock,
  lauracalcei,
  marinecaillis,
  solenenavaron,
  celineregina,
  laurianeheim,
  vincentrouah,
  lucielegastelois,
  oceanefloirac,
];
